<template>
    <div class="modal-box" v-loading="loading">
        <div class="modal-box-inner with-title">
            <div class="modal-box-content add-ip-address">

              <div class="modal-box-content-form-desktop">
                <el-form ref="formDesktop" :rules="rules" :model="form" @submit.prevent.native="formSubmit('formDesktop')">
                  <el-form-item prop="alias">
                    <el-input v-model="form.alias" ref="email" placeholder="alias" tabindex="1"></el-input>
                  </el-form-item>
                  <div class="modal-box-content-form-row">
                    <div class="modal-box-content-form-column">
                      <el-form-item prop="isp">
                        <el-input ref="isp" v-model="form.isp" placeholder="isp" tabindex="2"></el-input>
                      </el-form-item>
                    </div>
                    <div class="modal-box-content-form-column margin-bottom-extended">
                      <el-form-item prop="ip">
                        <el-input ref="ip" v-model="form.ip" placeholder="ip address" tabindex="3"></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="modal-box-actions">
                    <button native-type="submit" type="primary" class="modal-box-actions-item button" tabindex="8">add ip address</button>

                    <button native-type="button" @click.prevent="close" type="text" class="modal-box-actions-item button white">cancel</button>
                  </div>

                </el-form>
              </div>

              <div class="modal-box-content-form-mobile">
                <el-form ref="formMobile" :rules="rules" :model="form" @submit.prevent.native="formSubmit('formMobile')">

                  <el-form-item prop="alias">
                    <el-input v-model="form.alias" ref="email" placeholder="alias" tabindex="1"></el-input>
                  </el-form-item>

                  <el-form-item prop="isp">
                    <el-input ref="isp" v-model="form.isp" placeholder="isp" tabindex="2"></el-input>
                  </el-form-item>

                  <el-form-item prop="ip">
                    <el-input ref="ip" v-model="form.ip" placeholder="ip address" tabindex="3"></el-input>
                  </el-form-item>

                  <div class="modal-box-actions">
                    <button native-type="submit" type="primary" class="modal-box-actions-item button">add ip address</button>

                    <button native-type="button" @click.prevent="close" type="text" class="modal-box-actions-item button white">Cancel</button>
                  </div>

                </el-form>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'AddressAddModal',
  data () {
    return {
      loading: false,
      form: {
        ip: null,
        isp: null,
        alias: null
      }
    }
  },
  computed: {
    rules: function () {
      return {
        ip: [
          { required: true, message: 'Please enter ip address', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          HTTP({
            method: 'POST',
            url: '/api/v1/whitelistip',
            crossdomain: true,
            data: this.form
          }).then(() => {
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: 'Address added',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
            this.form = {
              ip: null,
              isp: null,
              alias: null
            }
            this.close()
            EventBus.$emit('reload-ip-addresses')
          }).catch(error => {
            this.loading = false
            this.$notify({
              dangerouslyUseHTMLString: true,
              message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
              type: 'error',
              position: 'bottom-right',
              duration: 1750
            })
          })
        } else {
          return false
        }
      })
    },
    close () {
      this.$emit('close')
    },
    isBlank (str) {
      return (!str || /^\s*$/.test(str))
    }
  }
}
</script>
